export const setUIFromQueryParams = ({ UI, queryParams }) => {
  if (queryParams.hideLogin) {
    UI.setHideLogin(queryParams.hideLogin);
  }
};
